import React, { useState, useEffect } from 'react';
import { Box, Button, Divider, Typography, CircularProgress, Avatar, Card } from '@mui/material';
import Label from 'src/components/Label';
import palette from 'src/theme/palette';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import ImgsViewer from 'react-images-viewer';
import { api } from 'src/Api';

export default function JobDetailModal({ handleClose, details, refresh }) {
  const [jobDetail, setJobDetail] = useState('');
  const [productloading, setproductloading] = useState(false);

  function getJob() {
    setJobDetail(details);
  }

  const [imagesMultiple, setimagesMultiple] = useState([]);
  const [fullImage, setfullImage] = useState(false);
  const [mainLength, setmainLength] = useState(0);

  // function imagesArray() {
  //   setmainLength(imagesMultiple?.length);
  //   imagesMultiple?.length = 0;
  //   if (productDetails?.media?.length > 0) {
  //     productDetails?.media?.map((item, index) => {
  //       if (item?.type == 'images' || item?.type == 'image') {
  //         setimagesMultiple((imagesMultiple) => [
  //           ...imagesMultiple,
  //           {
  //             src: item?.uri
  //           }
  //         ]);
  //       }
  //     });
  //   }
  // }

  // useEffect(() => {
  //   imagesArray();
  // }, []);

  function getJobDetail() {
    setproductloading(true);
    const myHeaders = new Headers();
    const token = localStorage.getItem('token');
    myHeaders.append('Authorization', `Bearer ${token}`);
    const params = new URLSearchParams();
    params.append('id', details?.id);
    const requestOptions = {
      method: 'GET',
      headers: myHeaders,
      redirect: 'follow'
    };
    const url = `${api.get_job_by_id}?${params.toString()}`;
    fetch(url, requestOptions)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else {
          throw new Error(`Error: ${response.status}`);
        }
      })
      .then((result) => {
        console.log('result of job detail ==', result);
        setJobDetail(result?.data);
      })
      .catch((error) => {})
      .finally(() => {
        setproductloading(false);
      });
  }

  useEffect(() => {
    getJobDetail();
  }, [details?.id]);

  // useEffect(() => {
  //   getJob();
  // }, []);

  const [index, setindex] = useState(0);

  function gotoPrevious() {
    if (index >= 0 && index <= mainLength) {
      setindex(index - 1);
    }
  }
  function gotoNext() {
    if (index >= 0 && index < mainLength) {
      setindex(index + 1);
    }
  }

  function settingFullImage(index) {
    // imagesArray();
    setindex(index);
    setfullImage(true);
  }

  const headingTypography = { fontSize: 14, fontWeight: 'bold', paddingRight: 1 };
  const headingDescription = { fontSize: 14 };
  // console.log('product dtail sset value', jobDetail);
  const getStatusColor = (status) => {
    switch (status?.toLowerCase()) {
      case 'active':
        return 'success';
      case 'delete':
        return 'error';
      case 'pending':
        return 'info';
      case 'hired':
        return 'warning';
      case 'paused':
        return 'secondary';
      default:
        return 'primary';
    }
  };

  return (
    <Box>
      <>
        {productloading ? (
          <Box
            style={{
              flex: 1,
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              alignContent: 'center',
              height: 500
            }}
          >
            <CircularProgress />
          </Box>
        ) : (
          <>
            <Box>
              <Typography
                row
                sx={{ fontSize: 18, fontWeight: 'bold', textAlign: 'center', marginTop: 2 }}
                component="div"
              >
                Job Detail
              </Typography>
            </Box>
            <Box
              pb={2}
              sx={{
                backgroundColor: '#151921',
                top: 0,
                borderBottom: '2px solid',
                borderColor: palette.primary.main,
                zIndex: 5,
                flexDirection: 'row',
                display: 'flex',
                justifyContent: 'space-between'
              }}
            >
              <Box px={4}>
                <Typography row sx={{ fontSize: 16, fontWeight: 'bold' }} component="div">
                  Job Title: {jobDetail?.title}
                </Typography>
              </Box>

              <Box px={2} style={{ alignItems: 'center', display: 'flex', flexWrap: 'wrap' }}>
                <Button color="primary" variant="contained" onClick={handleClose} size={'small'}>
                  Close
                </Button>
              </Box>
            </Box>
            <Box mt={2} style={{ flex: 1, justifyContent: 'center', display: 'flex' }}>
              {jobDetail?.video && jobDetail?.video?.media && (
                <video width="800" height="500" controls>
                  <source src={jobDetail.video.media} type="video/mp4" />
                </video>
              )}
            </Box>
            <Box px={2} py={2} className="property_Modal_Padding">
              <Card
                variant="outlined"
                style={{ paddingLeft: 20, paddingRight: 20, paddingTop: 20, paddingBottom: 10 }}
              >
                <Box display={'flex'} flexDirection={'row'} alignItems={'center'}>
                  <Typography sx={headingTypography} component="div">
                    Location:
                  </Typography>

                  <Typography
                    row
                    sx={{ ...headingDescription, textAlign: 'justify' }}
                    component="div"
                  >
                    {jobDetail?.location ? jobDetail?.location : 'N/A'}
                  </Typography>
                </Box>

                <Box
                  py={0}
                  width="100%"
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    // marginBottom: 2
                    marginTop: 5
                  }}
                  className="column"
                >
                  <Typography sx={headingTypography} component="div">
                    Job Type:
                  </Typography>

                  <Typography
                    row
                    sx={{ ...headingDescription, textAlign: 'justify' }}
                    component="div"
                  >
                    {jobDetail?.job_type?.name ? jobDetail?.job_type?.name : 'N/A'}
                  </Typography>
                </Box>
                <Box
                  py={1}
                  width="100%"
                  style={{
                    display: 'flex',
                    flexDirection: 'row'
                  }}
                  className="column"
                >
                  <Typography sx={headingTypography} component="div">
                    Salary:
                  </Typography>

                  <Typography
                    row
                    sx={{ ...headingDescription, textAlign: 'justify' }}
                    component="div"
                  >
                    <span>
                      {jobDetail?.currency ? `${jobDetail.currency} ` : ''}
                      {jobDetail?.salary ? `${jobDetail.salary} ` : ''}
                      {jobDetail?.salary_type?.name ? jobDetail.salary_type.name : ''}
                    </span>
                  </Typography>
                </Box>
                <Box
                  py={0}
                  width="100%"
                  style={{
                    display: 'flex',
                    flexDirection: 'row'
                  }}
                  className="column"
                >
                  <Typography sx={headingTypography} component="div">
                    Job Category:
                  </Typography>
                  <Typography
                    row
                    sx={{ ...headingDescription, textAlign: 'justify' }}
                    component="div"
                  >
                    {jobDetail?.job_category?.name || 'N/A'}
                  </Typography>
                </Box>
              </Card>
              {/* IMAGE SLIDER WHOLE SCREEN */}
              <ImgsViewer
                imgs={imagesMultiple}
                currImg={index}
                onClickPrev={gotoPrevious}
                onClickNext={gotoNext}
                isOpen={fullImage}
                onClose={() => setfullImage(false)}
              />

              {/* DESCRIPTION */}
              <Card
                variant="outlined"
                style={{
                  paddingLeft: 20,
                  paddingRight: 20,
                  paddingTop: 20,
                  paddingBottom: 10,
                  marginTop: 10
                }}
              >
                {/* CATEGORY */}

                <>
                  <Box
                    py={0.5}
                    width="100%"
                    style={{
                      display: 'flex',
                      flexDirection: 'row'
                    }}
                  >
                    <Typography sx={headingTypography} component="div">
                      Work Arrangement:
                    </Typography>

                    <Typography
                      row
                      sx={headingDescription}
                      component="div"
                      textTransform={'capitalize'}
                    >
                      {jobDetail?.work_arrangement?.name || 'N/A'}
                    </Typography>
                  </Box>
                  {/* <Divider /> */}
                </>
                {/* BRAND */}
                <>
                  <Box
                    py={0.5}
                    width="100%"
                    style={{
                      display: 'flex',
                      flexDirection: 'row'
                    }}
                  >
                    <Typography sx={headingTypography} component="div">
                      Experience Level:
                    </Typography>

                    <Typography row sx={headingDescription} component="div">
                      {jobDetail?.experience_level?.name || 'N/A'}
                    </Typography>
                  </Box>
                  {/* <Divider /> */}
                </>
                {/* BRAND */}
                <>
                  <Box
                    py={0.5}
                    width="100%"
                    style={{
                      display: 'flex',
                      flexDirection: 'row'
                    }}
                  >
                    <Typography sx={headingTypography} component="div">
                      Education Level:
                    </Typography>

                    <Typography row sx={headingDescription} component="div">
                      {jobDetail?.education_level?.name || 'N/A'}
                    </Typography>
                  </Box>
                  {/* <Divider /> */}
                </>
                {/* COLORS */}
                <>
                  <Box
                    py={0.5}
                    width="100%"
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      alignItems: 'center'
                    }}
                  >
                    <Typography sx={headingTypography} component="div">
                      Shift Type:
                    </Typography>
                    <Typography row sx={headingDescription} component="div">
                      {jobDetail?.shift_type?.name || 'N/A'}
                    </Typography>
                  </Box>
                  {/* <Divider /> */}
                </>
                {/* <Box flex={'display'}>
                  <Typography sx={headingTypography} component="div">
                    Skills:
                  </Typography>
                  {jobDetail?.skills?.length > 0 &&
                    jobDetail.skills.map((value, index) => (
                      <Box
                        key={index}
                        py={0.5}
                        width="100%"
                        style={{
                          display: 'flex',
                          flexDirection: 'row',
                          alignItems: 'center'
                        }}
                      >
                        <Typography sx={headingDescription} component="div">
                          {value?.name}
                        </Typography>
                      </Box>
                    ))}
                </Box> */}
                <Box display="flex" flexDirection="row" flexWrap="wrap" gap={1} alignItems="center">
                  <Typography sx={headingTypography} component="div">
                    Skills:
                  </Typography>

                  {(jobDetail?.skills?.length > 0 &&
                    jobDetail.skills.map((value, index) => (
                      <Box
                        key={index}
                        px={1.5}
                        py={0.5}
                        borderRadius={1}
                        bgcolor="#3F90DF" // Change to your desired background color
                        display="flex"
                        alignItems="center"
                      >
                        <Typography sx={headingDescription} color={'#fff'} component="div">
                          {value?.name}
                        </Typography>
                      </Box>
                    ))) ||
                    'N/A'}
                </Box>
              </Card>

              {/* {jobDetail?.description != null && ( */}
              <>
                <Box
                  py={1}
                  width="100%"
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    marginLeft: 20
                  }}
                  className="column"
                >
                  <Typography sx={headingTypography} component="div">
                    Job Description:
                  </Typography>

                  <Typography
                    row
                    sx={{ ...headingDescription, textAlign: 'justify' }}
                    component="div"
                  >
                    {jobDetail?.description || 'N/A'}
                  </Typography>
                </Box>
                {/* <Divider /> */}
              </>
              {/* )} */}

              {/* {jobDetail?.job_link != null && ( */}
              <>
                <Box
                  // py={1}
                  width="100%"
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    marginLeft: 20
                  }}
                  className="column"
                >
                  <Typography sx={headingTypography} component="div">
                    Job Link:
                  </Typography>

                  <Typography
                    row
                    sx={{ ...headingDescription, textAlign: 'justify' }}
                    component="div"
                  >
                    {jobDetail?.job_link || 'N/A'}
                  </Typography>
                </Box>
                {/* <Divider /> */}
              </>
              {/* )} */}

              {/* STATUS */}
              {/* {jobDetail?.status && ( */}
              <>
                <Box
                  py={0.5}
                  width="100%"
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    marginLeft: 20
                  }}
                >
                  <Typography sx={headingTypography} component="div">
                    Status:
                  </Typography>

                  <Label
                    style={{ height: 30, paddingLeft: 5, paddingRight: 5, width: 80 }}
                    variant="ghost"
                    color={getStatusColor(jobDetail?.status)}
                  >
                    <Typography
                      row
                      sx={{ fontWeight: 'bold', fontSize: 12, textTransform: 'capitalize' }}
                      component="div"
                    >
                      {jobDetail?.status || 'N/A'}
                    </Typography>
                  </Label>
                </Box>
                {/* <Divider /> */}
              </>
              {/* )} */}
              {/* DECLINED REASON */}
              {/* {jobDetail?.status?.toLowerCase() == 'declined' && ( */}
              <>
                {/* <Box
                  // py={1}
                  width="100%"
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    marginLeft: 20
                  }}
                >
                  <Typography sx={headingTypography} component="div">
                    Decline Reason:
                  </Typography>

                  <Typography
                    row
                    sx={headingDescription}
                    component="div"
                    textTransform={'capitalize'}
                  >
                    {jobDetail?.reason || 'N/A'}
                  </Typography>
                </Box> */}
                {/* <Divider /> */}
              </>
              {/* )} */}

              {/* {jobDetail?.published_at && ( */}
              <>
                <Box
                  py={1}
                  width="100%"
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    marginLeft: 20
                  }}
                >
                  <Typography sx={headingTypography} component="div">
                    Published Date:
                  </Typography>

                  <Typography row sx={headingDescription} component="div">
                    {jobDetail?.published_at}
                  </Typography>
                </Box>
                <Divider />
              </>
              {/* )} */}
              {/* VIEWS AND LIKES */}
              <Divider />
            </Box>
          </>
        )}
      </>
    </Box>
  );
}
